import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import { EMPTY_ARRAY } from 'commons-ui';

import { HasPermissionArgument } from 'routes/usePermission';

type ABTestActionListParams = {
	appName: string;
	hasPermission: ({ configPageName, entity, action }: HasPermissionArgument) => boolean;
};

export const makeActionList = (params: ABTestActionListParams) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: 'Revert to this version',
				id: 'revertExperimentToVersion',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.abTest,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].revertExperimentToVersion,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
